import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 公共路由
export const constantRoutes = [
    {
        path : '',
        name : 'home',
        component: (resolve) => require(['@/views/index'], resolve),
        meta: { title: '杭州好面科技有限公司'  }
    }, {
        path : '/index',
        name : 'index',
        component: (resolve) => require(['@/views/index'], resolve),
        meta: { title: '杭州好面科技有限公司'  }
    },{
        path : '/phoneIndex',
        name : 'phoneIndex',
        component: (resolve) => require(['@/views/phoneIndex'], resolve),
        meta: { title: '杭州好面科技有限公司'  }
    },
]
export default new Router({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

